export const testValidateEmail = (strEmail: string) => /\S+@\S+\.\S+/.test(strEmail)
